import { AxiosResponse } from 'axios';
import ApiUrls from '../config/ApiUrls';
import { replaceByObject } from '../utils/Urls';
import API from './Api';

export type NominalCodeApportionment = {
  ncExternalId: string,
};

export type TrackingCategoryApportionment = {
  typeId: string,
  nameId: string,
};

export type ApportionmentAssignment = {
  id: number,
  type: string,
  organisationId: number,
  nominalCode: NominalCodeApportionment,
  trackingCategories: TrackingCategoryApportionment[],
};

export type ApportionmentSplit = {
  split: number,
  siblingId: number,
  subApportionment: ApportionmentApiResponse | ApportionmentAssignment,
};

export type ApportionmentApiResponse = {
  id: number,
  name: string,
  total: number,
  type: string,
  visibility: string,
  splitsUnit: string,
  splits: ApportionmentSplit[],
  deletable?: boolean,
  accountCodeAction: string,
  trackingCategoryAction: {
    [key: string]: string,
  },
};

export class ApportionmentApi extends API {
  static getByGroup(groupId: number): Promise<ApportionmentApiResponse[]> {
    return API.get(
      replaceByObject(ApiUrls.GroupApportionments, { groupId })
    ).then((response: AxiosResponse<ApportionmentApiResponse[]>) => response.data);
  }

  static createApportionment(groupId: number, data: ApportionmentApiResponse): Promise<ApportionmentApiResponse> {
    return API.post(
      replaceByObject(ApiUrls.GroupApportionments, { groupId }),
      data
    ).then((response: AxiosResponse<ApportionmentApiResponse>) => response.data);
  }

  static updateApportionment(groupId: number, apportionmentId: number, data: ApportionmentApiResponse): Promise<ApportionmentApiResponse> {
    return API.put(
      replaceByObject(ApiUrls.GroupApportionment, { groupId, apportionmentId }),
      data
    ).then((response: AxiosResponse<ApportionmentApiResponse>) => response.data);
  }

  static deleteApportionment(groupId: number, apportionmentId: number): Promise<AxiosResponse> {
    return API.delete(
      replaceByObject(ApiUrls.GroupApportionment, { groupId, apportionmentId })
    );
  }
}
